export default __webpack_public_path__ + "static/media/Equipe (Real Size).37af5378.svg";